<template>
  <div id="app">
    <H2>{{ msg }}</H2>
  </div>
</template>
<script>
import headBack from "../common/head-back";
//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";

export default {
  name: "app",
  data() {
    return {
      msg: "",
      cid: null
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var channelId = this.$route.params.channelId;
    console.log("sharchannelIdeid:" + channelId);
    // this.type =type;
    // this.shareid =shareid;
    // if(!util.isNum(this.channelId)){
    //     tips.toast("地址不合法")
    //     this.$router.push("/index");
    // }
    store.commit(types.SET_CHANNEL, channelId);
    this.cid = channelId;
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
    } else {
      if (/(Android)/i.test(navigator.userAgent)) {
        var cid = channelId;
        if (
          "C001001" == cid ||
          "C001002" == cid ||
          "C001002" == cid ||
          "C001003" == cid ||
          "C001004" == cid ||
          "C001005" == cid ||
          "C001006" == cid ||
          "C001007" == cid ||
          "C001008" == cid ||
          "C001009" == cid ||
          "C001011" == cid ||
          "C001014" == cid ||
          "C001013" == cid ||
          "C001012" == cid
        ) {
          //下载
          this.$point.eventuid(
            "down_app_calc_" + channelId,
            channelId,
            "down_app"
          );
          window.location =
            "http://calc.haoyunba.com/apk/clac_android_V1.0.0_100_" +
            channelId +
            "_sign.apk";
          window.close();

        } else {
          this.$point.eventuid(
            "down_app_calc_" + channelId,
            channelId,
            "down_app"
          );
          window.location =
            "http://calc.haoyunba.com/apk/clac_android.apk";

                    

        }
      } else {
           this.$point.eventuid(
            "down_app_calc_ios" + channelId,
            channelId,
            "down_app"
          );
        //window.location = "https://apps.apple.com/cn/app/id1502944777";
    
           //使用企业签签名作为下载的标识
            setTimeout(() => {
              this.$router.push("/iosSetting");
            }, 2000);

            window.location.href =
              "itms-services://?action=download-manifest&url=https://www.haoyunba.com/h5/ios/clac/manifest.plist";

      }
    }
  },

  components: {
    headBack
  }
};
</script>
<style  scoped>
</style>


// WEBPACK FOOTER //
// src/components/downapp/downCalc.vue